export default "__VITE_ASSET__4afb3d06__"